import { render } from "./AnalisiDelTalento.vue?vue&type=template&id=3dcbd4b4"
import script from "./AnalisiDelTalento.vue?vue&type=script&lang=js"
export * from "./AnalisiDelTalento.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__